import React from 'react'
import Login from '../Login/login'
import ToShopOnlineButton from '../ToShopOnlineButton/toShopOnlineButton'
import OndemandLogo from '../../Assets/Image/ondemand_logo.png'
import "../Navbar/navbar.css"

const Navbar = () => {

  const toShopOnline = () => {
    window.open(process.env.REACT_APP_SHOPONLINE_URL, "_blank")
  }

  return (
    <React.Fragment>
    <nav className="navbar container">
        <img src={OndemandLogo} 
             alt="ondemand-logo" 
             onClick={() => window.location.href = "/"} />
        <div className='navbar-button'>
            <ToShopOnlineButton content="ShopOnline" onClick={toShopOnline} />
            <Login />
        </div>
    </nav>
    <hr />
    </React.Fragment>
    )
}

export default Navbar
